import { ApiBase } from '../ApiBase';
class MembershipsSpotifyIntegrationsApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getPodcastPreview = (params) => {
            return this.get(`/creators/api/v1/integrations/spotify/podcasts/preview`, params);
        };
        this.getPodcasts = () => {
            return this.get('/creators/api/v1/integrations/spotify/podcasts');
        };
        this.getPodcast = (params) => {
            return this.get(`/creators/api/v1/integrations/spotify/podcasts/${params.id}`);
        };
        this.createPodcast = (requestBody) => {
            return this.post('/creators/api/v1/integrations/spotify/podcasts', requestBody);
        };
        this.createPodcastFromUrl = (requestBody) => {
            return this.post('/creators/api/v1/integrations/spotify/podcasts/create_from_url', requestBody);
        };
        this.updatePodcast = (params, requestBody) => {
            return this.patch(`/creators/api/v1/integrations/spotify/podcasts/${params.id}`, requestBody);
        };
        this.deletePodcast = (params) => {
            return this.delete(`/creators/api/v1/integrations/spotify/podcasts/${params.id}`);
        };
        this.updateTags = (params, requestBody) => {
            return this.patch(`/creators/api/v1/integrations/spotify/podcasts/${params.podcast_id}/tags`, requestBody);
        };
        this.syncPodcast = (params) => {
            return this.post(`/creators/api/v1/integrations/spotify/podcasts/${params.id}/sync`);
        };
        this.desyncPodcast = (params) => {
            return this.post(`/creators/api/v1/integrations/spotify/podcasts/${params.id}/desync`);
        };
    }
}
export const MembershipsSpotifyIntegrationsApiClient = new MembershipsSpotifyIntegrationsApiClientModel('/');
